export class AuthFetchService {
  // Método para adicionar o token ao cabeçalho e fazer a requisição com fetch
  public fetchWithAuth(input: RequestInfo, init?: RequestInit): Promise<Response> {
    let token = '';

    // Verifique se o localStorage está acessível
    if (typeof window !== 'undefined' && window.localStorage) {
      try {
        token = localStorage.getItem('jwt') || ''; // Pegue o token JWT
      } catch (error) {
        console.warn('localStorage não está acessível:', error);
      }
    }



    // Adicione o cabeçalho de Authorization
    const authHeaders = {
      ...init?.headers,
      Authorization: `Bearer ${token}`,
      'Content-Type': "application/json"
    };
    

    // Combine os novos headers com as opções da requisição
    const newInit: RequestInit = {
      ...init,
      headers: authHeaders
    };

    // Retorne a requisição fetch com os headers de autorização
    return fetch(input, newInit);
  }
}
